// Full searchable radio details from the supplied 2023 statewide channel plan.
export default String.raw`13.1|154.28000|156.7|154.28000|156.7|H|N|
13.2|154.26500|156.7|154.26500|156.7|L|N|
13.3|154.29500|156.7|154.29500|156.7|L|N|
13.4|154.27250|156.7|154.27250|156.7|L|N|
13.5|154.28750|156.7|154.28750|156.7|L|N|
13.6|154.30250|156.7|154.30250|156.7|L|N|
13.7|156.07500|156.7|156.07500|156.7|L|N|
13.8|155.75250|000.0|155.75250|156.7|L|N|
13.9|151.13750|156.7|151.13750|156.7|L|N|
13.10|154.45250|156.7|154.45250|156.7|L|N|
13.11|158.73750|156.7|158.73750|156.7|L|N|
13.12|159.47250|156.7|159.47250|156.7|L|N|
13.13|159.47250|000.0|151.13750|136.5|L|N|
13.14|158.73750|000.0|154.45250|136.5|L|N|
13.15|159.47250|000.0|158.73750|136.5|L|N|
13.16|151.13750|000.0|159.47250|136.5|L|N|
13.17|154.45250|000.0|158.73750|136.5|L|N|
13.18|158.73750|000.0|159.47250|136.5|L|N|
13.19|154.16000|000.0|159.13500|000.0|H|N|
13.20|154.16000|000.0|159.19500|000.0|H|N|
13.21|154.22000|000.0|159.13500|000.0|H|N|
13.22|154.22000|000.0|159.19500|000.0|H|N|
13.23|153.75500|000.0|154.98000|000.0|H|N|Travel Net
13.24|168.62500|000.0|168.62500|110.9|L|N|Emergency
14.1|151.34000|136.5|159.31500|000.0|H|N|State
14.2|151.46000|136.5|159.39000|000.0|H|N|
14.3|151.2500|103.5|159.3600|000.0|H|N|
14.4|151.15250|136.5|159.3375|000.0|H|N|New Frequency
14.5|151.16000|192.8|151.16000|192.8|L|N|
14.6|151.19000|192.8|151.19000|192.8|L|N|
14.7|151.25000|192.8|151.25000|192.8|L|N|
14.8|151.32500|192.8|151.32500|192.8|L|N|
14.9|151.40000|192.8|151.40000|192.8|L|N|
14.10|154.28000|156.7|154.28000|156.7|H|N|
14.11|154.26500|156.7|154.26500|156.7|L|N|
14.12|154.29500|156.7|154.29500|156.7|L|N|
14.13|154.30250|156.7|154.30250|156.7|L|N|
14.14|156.07500|156.7|156.07500|156.7|H|N|
14.15|155.02500|88.5|154.05500|000.0|H|N|Lake
14.16|154.17500|88.5|154.17500|88.5|L|N|
14.17|154.23500|88.5|154.23500|88.5|L|N|
14.18|155.70750|162.2|159.10500|162.2|H|N|
14.19|151.82000|206.5|151.82000|206.5|L|N|
14.20|171.55000|000.0|164.50000|000.0|H|N|Mendocino
14.21|169.97500|000.0|169.17500|000.0|H|N|
14.22|172.40000|000.0|164.12500|000.0|H|N|
14.23|151.08500|136.5|156.19500|000.0|H|N|
14.24|153.95000|123.0|154.38500|000.0|H|N|
14.25|154.41500|131.8|154.86000|000.0|H|N|Napa
14.26|161.85000|000.0|161.85000|100.0|L|N|
14.27|154.32500|131.8|154.32500|131.8|L|N|
14.28|155.80500|131.8|158.94000|000.0|H|N|
14.29|153.95000|146.2|153.95000|146.2|L|N|
14.30|150.80500|241.8|150.80500|241.8|L|N|
14.31|155.10000|131.8|155.10000|131.8|L|N|
14.32|154.35500|131.8|154.35500|131.8|L|N|
14.33|154.19000|71.9|156.18000|71.9|H|N|
14.34|153.89000|127.3|153.89000|127.3|L|N|
14.35|154.31000|146.2|159.91500|146.2|H|N|Sonoma
14.36|155.26500|123.0|159.45750|123.0|H|N|
14.37|154.14500|146.2|158.98500|146.2|H|N|
14.38|154.17500|156.7|159.41250|156.7|H|N|
14.39|154.02500|107.2|154.02500|107.2|L|N|
14.40|153.77000|146.2|153.77000|146.2|L|N|
14.41|154.20500|146.2|154.20500|146.2|L|N|
14.42|154.44500|146.2|154.44500|146.2|L|N|
14.43|154.25000|146.2|154.25000|146.2|L|N|
14.44|154.01000|146.2|154.01000|146.2|L|N|
14.45|154.99500|146.2|154.99500|146.2|L|N|
14.46|154.07000|146.2|154.07000|146.2|L|N|
14.47|154.43000|146.2|154.43000|146.2|L|N|
14.48|153.99500|192.8|153.99500|192.8|L|N|
14.49|154.38500|146.2|154.38500|146.2|L|N|
14.50|155.89500|131.8|155.89500|131.8|L|N|
14.51|153.79250|156.7|153.79250|156.7|L|N|
14.52|154.15250|103.5|159.44250|103.5|H|N|
14.53|154.10000|103.5|156.04500|103.5|H|N|
14.54|151.10000|103.5|159.02250|103.5|H|N|
14.55|154.89000|186.2|158.94000|186.2|H|N|
14.56|151.13750|156.7|158.76750|162.2|H|N|
14.57|154.45250|156.7|156.06750|162.2|H|N|
14.58|158.73750|156.7|156.15000|162.2|H|N|
14.59|154.40000|156.7|158.87250|162.2|H|N|
14.60|151.01000|192.8|156.09750|192.8|H|N|
14.61|153.96500|156.7|153.96500|156.7|L|N|
14.62|155.07000|156.7|155.07000|156.7|L|N|
14.63|155.29500|156.7|155.29500|156.7|L|N|
14.64|154.78500|156.7|154.78500|156.7|L|N|
14.65|156.12000|156.7|156.12000|156.7|L|N|
14.66|155.37750|156.7|159.15000|000.0|H|N|
14.67|155.94000|179.9|154.04000|179.9|H|N|Yolo/Solano/Colusa/Contra Costa
14.68|159.61500|000.0|154.20500|186.2|H|N|
14.69|154.14500|107.2|155.92500|107.2|H|N|
14.70|154.17500|107.2|158.82000|146.2|H|N|
14.71|154.37000|100.0|158.79000|100.0|H|N|
14.72|156.00000|107.2|153.86000|107.2|H|N|
14.73|155.13000|107.2|156.19000|107.2|H|N|
14.74|154.34000|107.2|156.19500|186.2|H|N|
14.75|151.13000|107.2|159.10500|186.2|H|N|
14.76|155.52000|107.2|155.52000|107.2|L|N|
14.77|154.44500|000.0|159.52500|141.3|H|N|
14.78|151.08500|000.0|159.18000|141.3|H|N|
14.79|153.83000|000.0|153.83000|141.3|L|N|
14.80|158.83500|000.0|158.83500|141.3|L|N|
14.81|151.29500|110.9|000.00000|000.0||N|Air
14.82|151.31000|110.9|000.00000|000.0||N|Air
14.83|151.28750|110.9|000.00000|000.0||N|Air
14.84|151.2200|192.8|151.22000|192.8|L|N|
14.85|159.26250|192.8|159.26250|192.8|L|N|
14.86|159.36750|192.8|159.36750|192.8|L|N|
14.87|154.9200|156.7|154.9200|156.7|H|N|Interop Freqs
14.88|154.9350|156.7|154.9350|156.7|L|N|Interop Freqs
14.89|155.3175|D074N||||N|RX ONLY Clear Lake PD
14.90|155.9700|88.5||||N|RX ONLY Lake County SO
14.91|155.0700|88.5||||N|RX ONLY Lake County SO Tac 4
14.92|153.3650|000.0||||N|RX ONLY American Canyon Police
14.93|153.7850|000.0||||N|RX ONLY Calistoga PD
14.94|160.4850|000.0||||N|RX ONLY Napa Railroad Dispatch
14.95|160.5750|000.0||||N|RX ONLY Napa Railroad Operations
14.96|155.1000|131.8|155.8350|000.0|H|N|Napa AMR Disp - St Helena
14.97|155.4300|131.8||||N|RX ONLY Napa County SO Primary
14.98|156.0300|131.8||||N|RX ONLY Napa County SO Blue Tac
14.99|151.0700|131.8||||N|RX ONLY Napa County SO Red Tac
14.100|153.9800|131.8|158.8800|131.8|H|N|Napa Co Public Works
14.101|153.9800|131.8|158.8800|127.3|H|N|Napa Co Public Works
14.102|154.5150|131.8||||N|RX ONLY Pacific Union College-Blue
14.103|155.5650|127.3||||N|RX ONLY St Helena PD
14.104|155.0550|127.3||||N|RX ONLY St Helena Public Works
14.105|153.8450|000.0|153.8450|146.2|L|N|Cloverdale Public Works
14.106|155.1000|192.8|155.8350|000.0|H|N|Mendecino
14.107|154.2500|000.0|159.1800|156.7|H|N|Point Arena Repeater
14.108|153.8900|156.7|153.8900|156.7|L|N|South Coast Fire Tac B
14.109|155.1600|146.2|150.7900|146.2|H|N|Sonoma County SAR
14.110|156.4500|000.0|156.4500|000.0|L|W|
14.111|156.8000|000.0|156.8000|000.0|L|W|
14.112|156.8500|000.0|156.8500|000.0|L|W|
14.113|157.0500|000.0|157.0500|000.0|L|W|
14.114|157.1000|000.0|157.1000|000.0|L|W|
14.115|157.1500|000.0|157.1500|000.0|L|W|
14.116|154.9500|123.0||||N|RX ONLY Colusa County SO
14.117|155.1300|000.0||||N|RX ONLY Colusa County SO Tac
14.118|155.9100|000.0||||N|RX ONLY Colusa County ??
14.119|155.4900|107.2||||N|RX ONLY Solano County SO
14.120|154.8000|141.3||||N|RX ONLY Yolo County SO Primary
14.121|155.5950|000.0||||N|RX ONLY Yolo County So Tac
14.122|153.7550|000.0|154.9800|000.0|H|N|Travel Net
14.123|168.6250|000.0|168.6250|110.9|L|N|Emergency`;
